import { render, staticRenderFns } from "./Concepto.vue?vue&type=template&id=53680674&"
import script from "./Concepto.vue?vue&type=script&lang=js&"
export * from "./Concepto.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports